import format from 'date-fns/format';
import { isValid, parse } from 'date-fns';
import { getCurrentLocale } from 'cadenza/utils/i18n/i18n';
import { de, enUS } from 'date-fns/locale';

import { convertJavaToDateFnsDateFormat as toDateFnsFormat } from './java-to-date-fns-format';

export function formatDateWithJavaFormat (date, javaFormat) {
  return format(date, toDateFnsFormat(javaFormat), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
}

export function parseDateWithJavaFormat (dateString, javaFormat) {
  return parse(dateString, toDateFnsFormat(javaFormat), new Date(), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
}

export function parseAndValidateDateWithJavaFormat (dateString, javaFormat) {
  const parsedDate = parse(dateString, toDateFnsFormat(javaFormat), new Date(), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
  return isValid(parsedDate) ? parsedDate : null;
}

function getLocale () {
  return getCurrentLocale().startsWith('en') ? enUS : de;
}
